module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attr-panel",
    class: {
      'is-collapsed': _vm.isCollapsed,
      'is-expanded-view': _vm.isExpandedView
    },
    on: {
      "click": _vm.panelClickHandler
    }
  }, [(_vm.isCollapsed) ? _c('collapse-btn', {
    staticClass: "attr-panel__expand-btn",
    attrs: {
      "hide-text": true
    }
  }) : _vm._e(), _vm._v(" "), _c('header', {
    staticClass: "attr-panel__header"
  }, [_c('div', {
    staticClass: "attr-panel__header-nav"
  }, [_c('panel-size-btn', {
    attrs: {
      "is-expanded-view": _vm.isExpandedView
    },
    nativeOn: {
      "click": function($event) {
        return _vm.togglePanelSize.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('collapse-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.toggleCollapse.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), (_vm.currentTarget) ? _c('div', {
    staticClass: "attr-panel__target-info"
  }, [_c('v-row', {
    attrs: {
      "justify": "start"
    }
  }, [(!_vm.editModeActive) ? _c('v-col', [_vm._v("\n          " + _vm._s(_vm.currentTarget.display_name) + "\n        ")]) : _c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('target-name', {
    attrs: {
      "isNewTarget": false,
      "initialValue": _vm.originalDisplayName,
      "displayOverride": _vm.currentTarget.display_name,
      "targetType": _vm.currentTarget.target,
      "attributePanel": true
    },
    on: {
      "updateName": _vm.updateName,
      "updateNameIsValid": _vm.validateName
    }
  })], 1), _vm._v(" "), (!_vm.isAdvertiserEditable && _vm.currentTarget && _vm.currentTarget.advertiser && _vm.currentTarget.advertiser.Name) ? _c('v-col', [_vm._v("\n          " + _vm._s(_vm.currentTarget.advertiser.Name) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isAdvertiserEditable && _vm.currentTarget && _vm.currentTarget.advertiser) ? _c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('advertiser-select', {
    ref: "advertiserSelect",
    attrs: {
      "placeholder": "Select",
      "attributePanel": true,
      "initialValue": _vm.currentTarget.advertiser,
      "showAdvertiserId": false
    },
    on: {
      "update": function (val) { return _vm.changeAdvertiser(val); }
    },
    model: {
      value: (_vm.currentTarget.advertiser),
      callback: function($$v) {
        _vm.$set(_vm.currentTarget, "advertiser", $$v)
      },
      expression: "currentTarget.advertiser"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.targetEditable) ? _c('div', {
    staticClass: "attr-panel__target-info__edit-icon"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEditMode.apply(null, arguments)
      }
    }
  }, [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('search-input', {
    ref: "searchInput",
    staticClass: "attr-panel__search",
    attrs: {
      "debounce": 500
    },
    model: {
      value: (_vm.searchTerm),
      callback: function($$v) {
        _vm.searchTerm = $$v
      },
      expression: "searchTerm"
    }
  }), _vm._v(" "), _c('bread-crumbs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSearchActive),
      expression: "!isSearchActive"
    }],
    attrs: {
      "crumbs": _vm.crumbs
    },
    on: {
      "click": _vm.crumbClickHandler
    }
  }), _vm._v(" "), _c('back-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearchActive),
      expression: "isSearchActive"
    }],
    staticClass: "attr-panel__back-btn",
    nativeOn: {
      "click": function($event) {
        return _vm.clearSearch.apply(null, arguments)
      }
    }
  }, [_vm._v("Back To Browse")])], 1), _vm._v(" "), _c('div', {
    staticClass: "attr-panel__body"
  }, [(_vm.tooManySearchResults) ? _c('small-text', [_vm._v("\n      Too many results to display (" + _vm._s(_vm.searchResultsCount) + "). Please refine your search.\n    ")]) : (_vm.isSearchActive) ? _c('search-results', {
    ref: "searchResults",
    attrs: {
      "results": _vm.searchResults,
      "count": _vm.searchResultsCount
    },
    on: {
      "item-selected": _vm.itemSelectedHandler
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentList) ? _c('list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSearchActive),
      expression: "!isSearchActive"
    }],
    attrs: {
      "list-group": _vm.currentList,
      "id": "attributePanelID"
    },
    on: {
      "item-selected": _vm.itemSelectedHandler
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b0fed43"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/oldWorkbench/attributePanel/AttributePanel.vue
// module id = 1805
// module chunks = 0